// 引入封装好的SvgIcon组件
import SvgIcon from "@/components/SvgIcon.vue"; // svg component
import Vue from "vue";

// 全局注册
export const registerSvgIcon = (Vue) => {
  Vue.component("svgIcon", SvgIcon);
  const req = require.context("./svg/lni", false, /\.svg$/);
  // eslint-disable-next-line
  const requireAll = (requireContext) =>
    requireContext.keys().map(requireContext);
  requireAll(req);
};



// WEBPACK FOOTER //
// ./src/assets/index.js